<template>
	<div class="sticky bottom-0 pointer-events-none">
		<div class="flex flex-shrink flex-col justify-end" v-if="showChatPopup">
			<ChatPopup
				class="pointer-events-auto"
				@changeState="showChatPopup = $event"
				:chat-id="process.chat_id"
				:customer="process.customer"
				:damage-case-id="process.id"
			/>
		</div>
		<div class="flex-grow flex flex-col justify-end sticky bottom-0 bg-white bg-opacity-80 py-5 footer pointer-events-auto">
			<div class="flex" :class="{ 'justify-between': isBackButton, 'justify-end': !isBackButton }">
				<slot name="backButton">
					<BaseBackButton @click="backButtonClick()" :disabled="disableButtons" v-show="isBackButton" :back-button-title="backButtonTitle" />
				</slot>

				<div class="w-full flex justify-end" style="align-items: end">
					<BaseButton v-if="showChat" @click="setChatExpanded">
						{{ $t('chat') }}
					</BaseButton>
					<slot name="right"></slot>
					<BaseSkipButton @click="skipButtonClick()" :disabled="disableButtons" v-show="isSkippable" class="mr-4" />
					<slot name="continueButton">
						<BaseContinueButton @click="continueButtonClick()" :disabled="disableButtons || disableContinue" v-show="isContinueButton" />
					</slot>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import BaseSkipButton from '@/components/forms/buttons/BaseSkipButton';
import BaseContinueButton from '@/components/forms/buttons/BaseContinueButton';
import BaseBackButton from '@/components/forms/buttons/BaseBackButton';
import ChatPopup from '@/views/management/RepairShop/Chat/ChatPopup.vue';
import BaseButton from '@/components/forms/buttons/BaseButton.vue';

export default {
	name: 'Footer',
	components: {
		BaseButton,
		ChatPopup,
		BaseBackButton,
		BaseContinueButton,
		BaseSkipButton,
	},
	props: {
		process: { required: false },
		showChat: { required: false, default: false },
		disableButtons: { type: Boolean, default: false },
		disableContinue: { type: Boolean, default: false },
		isSkippable: {
			type: Boolean,
			default: false,
		},
		isBackButton: {
			type: Boolean,
			default: true,
		},
		backButtonTitle: {
			type: String,
			default: function() {
				return this.$t('general.back');
			},
		},
		isContinueButton: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {
			showChatPopup: false,
		};
	},
	mounted() {
		this.showChatPopup = this.$store.getters.getIsChatExpanded;
	},
	methods: {
		setChatExpanded() {
			if (this.process.customer.customer_main != null) {
				this.showChatPopup = !this.showChatPopup;
				this.$store.commit('setIsChatExpanded', this.showChatPopup);
			} else {
				this.$swal(this.$t('general.error').toString(), this.$t('customer_did_not_install_app').toString(), 'error');
			}
		},
		backButtonClick() {
			this.$emit('backButtonClick');
		},
		skipButtonClick() {
			this.$emit('skipButtonClick');
		},
		continueButtonClick() {
			this.$emit('continueButtonClick');
		},
	},
};
</script>

<style lang="sass" scoped></style>
